module.exports = __webpack_public_path__ + "static/media/img-digital-cash-horizontal.bfc240b8.pdf";